import React, {  useState } from "react";
import YearDropdown from "../../DateSelectors/YearDropdown";
import MonthDropdown from "../../DateSelectors/MonthDropdown";
import FormInput from "../../Forms/FormInput";
import CompanyMenu from "./CompanyMenu/CompanyMenu";
import { validate } from "../../validate";
import { IBLSpinLoader } from "../../../IBLSpinLoader";
import { createExperience, deleteExperience, updateExperience } from "../../helpers";
import { usePositionCompany } from "../../../../hooks/usePositionCompany";

const PositionMenu = ({ setShowPositionMenu, handleSuccess, positionData, setPositionData, menuTitle, isUpdate = false }) => {
  // Th code needs to improve. I am maintaining way too many states in the file and way too many functions. Maybe using useReducer and extracting \
  // the components/logic futher would also help.

     const requiredFields = [
       'title',
       'location',
       'description',
       'start_date',
       'start_year',
     ];



 const [showCompanyMenu, setShowCompanyMenu] = useState(false);
 const [isLoading, setIsLoading] = useState(true);

  const { companies, setCompanies } = usePositionCompany(isUpdate, positionData, setPositionData, setIsLoading);

 
  const [errors, setErrors] = useState({});

  const handleResponse = (data) => {
    if (data.success) {
      setIsLoading(false);
      window.alert('Operation successful');
      handleSuccess();
    }
    else {
      setIsLoading(false);
      window.alert('Something went wrong, Please try again later');
      setShowPositionMenu(false);
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPositionData({ ...positionData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };


  const deletePosition = (id) => {
    setIsLoading(true);
    deleteExperience(id, handleResponse);
  }

 



  const handleSave = () => {
    const newErrors = validate(positionData, requiredFields);
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (positionData.company_id === 0) {
      setErrors({ company_id: "please create a company frist" });
      return;
    }

  

  

    // Format the dates
    const formatDate = (year, date) =>
      `${year}-${new Date(Date.parse(date + ' 1, 2012')).getMonth() + 1}-01`;

    const start_date = formatDate(positionData.start_year, positionData.start_date);
    const end_date = formatDate(positionData.end_year, positionData.end_date);
    
if(!positionData.is_current){
  // Validate the start and end date
  if (new Date(start_date) > new Date(end_date)) {
    setErrors({ end_date: "the end date cannot be before the start date." });

    return;
  }
}
  

    

    const formData = {
      ...positionData,
      start_date: start_date,
      end_date: end_date ,
    };



  
    delete formData.start_year;
      if (positionData.is_current) {
        formData.end_date = null;
      }
    delete formData.end_year;


    setIsLoading(true);
  
    if (isUpdate) {
      updateExperience(formData, handleResponse);
    }
    else {
      createExperience(formData, handleResponse);
    }


   






  };

  const hideCompanyMenu = () => {
    setShowCompanyMenu(false);
  };

  const reviewCompanyMenu = () => {
    setShowCompanyMenu(true);
  };


  

  return (
    <>
      <div
        data-name="followers"
        className="edit_profile_pop add-position-pop hidden active"
        style={{ display: showCompanyMenu ? 'none' : 'block' }}
      >
        <div className="div-block-520">
          <div className="text-block-386">{menuTitle}</div>
          <div
            className="cancel_edit_profile w-embed"
            onClick={() => setShowPositionMenu(false)}
          ></div>
        </div>

        {isLoading ? (
          <IBLSpinLoader size={40} containerHeight={'200px'} />
        ) : (
          <>
            <div className="div-block-525">
              <div className="div-block-469 sk_s form_div">
                <div className="form_row">
                  <div className="text-block-297">Title</div>
                  <div className="form-block-15 s_skill w-form">
                    <form
                      id="email-form"
                      name="email-form"
                      data-name="Email Form"
                      method="get"
                      className="form-10"
                      data-wf-page-id="6596f9cde7a06c303cf07fbf"
                      data-wf-element-id="b1ab284e-ca86-ad5f-8152-1921d15697cf"
                      aria-label="Email Form"
                    >
                      <FormInput
                        name="title"
                        placeholder="E.g Software Engineer"
                        value={positionData.title}
                        onChange={handleInputChange}
                      />
                    </form>
                    {"title" in errors  && (
                      <div
                        className="error-message"
                        style={{ color: '#CB112D' }}
                      >
                        {errors.title as string}
                      </div>
                    )}
                  </div>
                </div>
                <div className="form_row">
                  <div className="text-block-297">Employment Type</div>
                  <div className="form-block-15 s_skill w-form">
                    <form
                      id="email-form"
                      name="email-form"
                      data-name="Email Form"
                      method="get"
                      className="form-10"
                      data-wf-page-id="6596f9cde7a06c303cf07fbf"
                      data-wf-element-id="828e0625-7656-d708-417d-1034b8c221db"
                      aria-label="Email Form"
                    >
                      <select
                        id="field-2"
                        name="employment_type"
                        data-name="Employment Type"
                        className="select-field-3 w-select"
                        onChange={handleInputChange}
                        value={positionData.employment_type}
                      >
                        <option value="Full Time">Full Time</option>
                        <option value="Part Time">Part Time</option>
                      </select>
                    </form>
                  </div>
                </div>
                <div className="form_row">
                  <div className="text-block-297">Company</div>
                  <div className="form-block-15 s_skill w-form">
                    <form
                      id="email-form"
                      name="email-form"
                      data-name="Email Form"
                      method="get"
                      className="form-10"
                      data-wf-page-id="6596f9cde7a06c303cf07fbf"
                      data-wf-element-id="8d07cdca-473b-6794-cdfc-2c33d3b803d2"
                      aria-label="Email Form"
                    >
                      {!isLoading && (
                          <select
                            id="field-4"
                            name="company_id"
                            data-name="Company"
                            className="select-field-3 w-select"
                            value={positionData.company_id}
                            onChange={handleInputChange}
                          >
                            {companies.length > 0 ? (
                              companies.map((company) => (
                                <option key={company.id} value={company.id}>
                                  {company.name}
                                </option>
                              ))
                            ) : (
                              <option value="0">Create Company</option>
                            )}
                          </select>
                      )}
                       
                    </form>
                     { "company_id" in errors  && (
                      <div
                        className="error-message"
                        style={{ color: '#CB112D' }}
                      >
                        {errors.company_id as string}
                      </div>
                    )}
                  </div>
                  <a
                    data-w-id="8d07cdca-473b-6794-cdfc-2c33d3b803da"
                    href="#"
                    onClick={reviewCompanyMenu}
                    className="link-block-35 w-inline-block"
                  >
                    <img
                      src="https://cdn.prod.website-files.com/6596e21ac435cac3c66baad8/66f2b9df760bcd7636eacf9a_plus.svg"
                      loading="lazy"
                      alt=""
                      className="image-234"
                    />
                    <h5 className="heading-13">Add new company</h5>
                  </a>
                </div>
                <div className="form_row">
                  <div className="text-block-297">Location</div>
                  <div className="form-block-15 s_skill w-form">
                    <form
                      id="email-form"
                      name="email-form"
                      data-name="Email Form"
                      method="get"
                      className="form-10"
                      data-wf-page-id="6596f9cde7a06c303cf07fbf"
                      data-wf-element-id="b1ab284e-ca86-ad5f-8152-1921d15697db"
                      aria-label="Email Form"
                    >
                      <FormInput
                        name="location"
                        placeholder="E.g San Francisco, CA"
                        value={positionData.location}
                        onChange={handleInputChange}
                      />
                    </form>
                    { "location" in errors  && (
                      <div
                        className="error-message"
                        style={{ color: '#CB112D' }}
                      >
                        {errors.location as string}
                      </div>
                    )}
                  </div>
                </div>
                <div className="form_row">
                  <div className="w-layout-hflex flex-block-55">
                    <div className="text-block-297 no-margin">Start date</div>
                    <div className="w-layout-hflex flex-block-56">
                      <div
                        react-component="ToolsRowSwitch"
                        className="html-embed-26 w-embed"
                      >
                        <style
                          dangerouslySetInnerHTML={{
                            __html:
                              '\n        /* The mini-switch - the box around the mini-switch-slider */\n        .mini-switch {\n            position: relative;\n            display: inline-block;\n            width: 30px;\n            height: 15px;\n        }\n\n        /* Hide default HTML checkbox */\n        .mini-switch input {\n            opacity: 0;\n            width: 0;\n            height: 0;\n        }\n\n        /* The mini-switch-slider */\n        .mini-switch-slider {\n            position: absolute;\n            cursor: pointer;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background-color: #ccc;\n            -webkit-transition: .4s;\n            transition: .4s;\n        }\n\n        .mini-switch-slider:before {\n            position: absolute;\n            content: "";\n            height: 9px;\n            width: 9px;\n            left: 4px;\n            bottom: 3px;\n            background-color: white;\n            -webkit-transition: .4s;\n            transition: .4s;\n        }\n\n        input:checked + .mini-switch-slider {\n            background-color: #2467eb;\n        }\n\n        input:focus + .mini-switch-slider {\n            box-shadow: 0 0 1px #2467eb;\n        }\n\n        input:checked + .mini-switch-slider:before {\n            -webkit-transform: translateX(14px);\n            -ms-transform: translateX(14px);\n            transform: translateX(14px);\n        }\n\n        /* Rounded mini-switch-sliders */\n        .mini-switch-slider.round {\n            border-radius: 20px;\n        }\n\n        .mini-switch-slider.round:before {\n            border-radius: 50%;\n        }\n    ',
                          }}
                        />
                        <label className="mini-switch">
                          <input
                            className="current-position-switcher"
                            type="checkbox"
                            name="is_current"
                            checked={positionData.is_current}
                            onChange={() =>
                              setPositionData((prevState) => ({
                                ...prevState,
                                is_current: !prevState.is_current,
                              }))
                            }
                          />
                          <span className="mini-switch-slider round" />
                        </label>
                      </div>
                      <h5 className="heading-14">Current</h5>
                    </div>
                  </div>
                  <div className="form-block-15 s_skill w-form">
                    <form
                      id="email-form"
                      name="email-form"
                      data-name="Email Form"
                      method="get"
                      className="form-10 no-bg"
                      data-wf-page-id="6596f9cde7a06c303cf07fbf"
                      data-wf-element-id="b1ab284e-ca86-ad5f-8152-1921d15697e7"
                      aria-label="Email Form"
                    >
                      <div className="w-layout-hflex flex-block-57">
                        {/* start month */}
                        <MonthDropdown
                          handleInputChange={handleInputChange}
                          name="start_date"
                          selectedMonth={isUpdate ? positionData.start_month : null}
                          errors={ "start_date" in errors ? errors.start_date : null}
                        />

                        <YearDropdown
                          handleInputChange={handleInputChange}
                          selectedYear={isUpdate ? positionData.start_year : null}
                          name="start_year"
                          errors={ "start_year" in errors ? errors.start_year : null}
                        />
                      </div>
                    </form>
                  </div>
                </div>
                {!positionData.is_current && (
                  <div className="form_row position-end-date-row">
                    <div
                      className="w-layout-hflex flex-block-55"
                      style={{
                        marginTop: `${ "start_date" in errors ? '40px' : '0px'}`,
                      }}
                    >
                      <div className="text-block-297 no-margin">End date</div>
                    </div>
                    <div className="form-block-15 s_skill w-form">
                      <form
                        id="email-form"
                        name="email-form"
                        data-name="Email Form"
                        method="get"
                        className="form-10 no-bg"
                        data-wf-page-id="6596f9cde7a06c303cf07fbf"
                        data-wf-element-id="4b9dd0de-d01b-39d1-881f-d09430fb6f86"
                        aria-label="Email Form"
                      >
                        <div className="w-layout-hflex flex-block-57">
                          {/* end year */}
                          <MonthDropdown
                            handleInputChange={handleInputChange}
                            selectedMonth={isUpdate ? positionData.end_month : null}
                            name="end_date"
                            errors={ "end_date" in errors ? errors.end_date : null}
                          />
                          <YearDropdown
                            handleInputChange={handleInputChange}
                            selectedYear={isUpdate ? positionData.end_year : null}
                            name="end_year"
                            errors={ "end_year" in errors ? errors.end_year : null}
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                )}

                <div
                  className="form_row"
                  style={{ marginTop: `${ "end_date" in errors ? '40px' : '0px'}` }}
                >
                  <div className="text-block-297">Description</div>
                  <div className="form-block-15 s_skill w-form">
                    <form
                      id="email-form"
                      name="email-form"
                      data-name="Email Form"
                      method="get"
                      className="form-10 h-text-area"
                      data-wf-page-id="6596f9cde7a06c303cf07fbf"
                      data-wf-element-id="7c8aa205-5100-af38-ed45-9b190a6a9192"
                      aria-label="Email Form"
                    >
                      <textarea
                        placeholder="Add some description"
                        maxLength={5000}
                        value={positionData.description}
                        name="description"
                        data-name="Description"
                        className="textarea-6 w-input"
                        onChange={handleInputChange}
                      />
                    </form>
                  </div>
                    { "description" in errors  && (
                    <div className="error-message" style={{ color: '#CB112D' }}>
                      {errors.description as string}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="popup-f add_content">
              <div
                className="div-block-475 cancel_edit_prof"
                onClick={() => setShowPositionMenu(false)}
              >
                <div className="text-block-284 cancel_dc">Cancel</div>
              </div>

              {isUpdate && (
                <>
                <div className="div-block-475 delete-skills"style={{width: '130px'}}
                onClick={() => deletePosition(positionData.id)}  
                    ><div className="text-block-284 add_skill_text cancel delete-s">Delete Position</div></div>
                </>
              )}


              <div
                className="div-block-475 save_profile_info"
                onClick={handleSave}
              >
                <div className="text-block-284 add_skill_text">Save</div>
              </div>
            </div>
          </>
        )}
      </div>

      {/* company menu here */}
      {showCompanyMenu && <CompanyMenu hideCompanyMenu={hideCompanyMenu} setCompanies={setCompanies} setPositionData={setPositionData} />}
    </>
  );
};

export default PositionMenu;